<template>
    <MainLayout selectMenu="1-1" siderMenu="19-1" sideBar="fix">
        <div v-if="!hasAuth">
            <NoAuth></NoAuth>
        </div>
        <div v-else>
            <div class="menu-actions">
                {{ getTranslation('p025') }}：<Input size="small" style="width: 50px;" type="number"
                    v-model="programBefore" />&nbsp;&nbsp;
                {{ getTranslation('p026') }}：<Input size="small" style="width: 50px;" type="number"
                    v-model="programAfter" />
                <Button type="primary" style="margin-left: 10px;" @click="query" icon="ios-search" size="small">{{
                    getTranslation('k176') }}</Button>
            </div>
            <Row type="flex">
                <Col flex="1">
                <div class="fix-record-block">
                    <fieldset class="my-fieldset ">
                        <legend class="my-legend">{{ getTranslation('p030') }}</legend>
                        <div v-if="isLoadingQuery" class="flex-middle">
                            <Spin size="large"></Spin>
                        </div>
                        <div v-else v-for="(record, index) in fixRecord" :key="index"
                            style="display:inline-flex;margin-top:10px;">
                            <div class="one-fix table-cell"><Button :type="selectType(index)" size="small"
                                    shape="circle" @click="selectRecord(index)">{{
                                        cutYear(record[0].created_string) }}~{{
                                        cutYear(record[1].created_string) }}</Button>
                            </div>
                        </div>
                        <div v-if="!isLoadingQuery && fixRecord.length === 0" style="margin-top:10px;">
                            <Alert>{{ getTranslation('p027') }}</Alert>
                        </div>
                    </fieldset>
                </div>
                <fieldset class="my-fieldset second-fieldset">
                    <legend class="my-legend">{{ getTranslation('p060') }}</legend>
                    <Row type="flex" class="menu-actions">
                        <Col flex="1" class="table-cell">
                        {{ getTranslation('p053') }}：<Input size="small" style="width: 100px;" type="number"
                            v-model="saveRange"></Input>&nbsp;μOhm&nbsp;<Button type="warning" :disabled="!canCreatRefCurve"
                            size="small" icon="md-create" style="margin-left: 10px;" @click="createRefCurve()">{{
                                getTranslation('k104') }}</Button>
                        </Col>
                    </Row>
                    <Row type="flex" class="menu-actions">
                        <Col flex="1" class="table-cell">
                        {{ getTranslation('p054') }}：<Input size="small" style="width: 100px;" type="number"
                            v-model="refRange"></Input>&nbsp;μOhm&nbsp;
                        <Button type="success" :disabled="!canSavingRefCurve" size="small" style="margin-left: 10px;"
                            icon="ios-checkmark-circle-outline" @click="saveRefCurve()">{{ getTranslation('p028')
                            }}</Button>
                        </Col>
                    </Row>
                </fieldset>
                </Col>
                <Col class="right-fix">
                <div v-if="isFromRecord" class="table-cell">{{ getTranslation('p059') }}</div>
                <div v-else class="table-cell">{{ getTranslation('p061') }}</div>
                <div ref="charts" :style="{ width: chartWidth, height: '500px' }"></div>
                </Col>
            </Row>
        </div>
    </MainLayout>
</template>

<script>
import MainLayout from '@/components/MainLayout.vue'
import NoAuth from '@/components/NoAuth.vue'
import { Button, Input, Spin, Alert, Row, Col } from 'view-design';
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { mapGetters } from 'vuex'
import { postJsError, jsonParseSafe, setDashboardPage, setSidbarBreadCrumb } from '@/util/util.js'

export default {
    name: 'FixIndex',
    components: {
        MainLayout,
        NoAuth, Input, Button, Spin, Alert, Row, Col
    },
    props: {

    },
    data() {
        return {
            hasAuth: true,
            programBefore: 0,
            programAfter: 1,
            mac: '',
            fixRecord: [],
            yAxisDefine: [],
            chartWidth: '100%',
            myChart: null,
            isSelecting: false,
            startPos: null,
            xAxisData: [],
            aSeries: [],
            // track legend selections to persist toggle state
            legendSelected: {},
            // 多选状态与缓存
            selectedMap: {},        // { [index]: true }
            parsedCache: {},         // { [index]: { before: Curve[], after: Curve[] } }
            saveRange: 10,
            refRange: 10,
            // cache the grid rect during selection to keep alignment
            gridRect: null,
            isLoadingQuery: false,
            isFromRecord: false,
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        canCreatRefCurve() {
            return Object.keys(this.selectedMap).length > 0;
        },
        canSavingRefCurve() {
            return this.aSeries.some(s => s.key === 'fix-before-avg') &&
                this.aSeries.some(s => s.key === 'fix-after-avg') && !this.isFromRecord;
        }
    },
    watch: {

    },
    created() {
        setDashboardPage('fix');
        this.mac = this.$route.query.mac;
        this.initChart();
        this.initRefCurve();
    },
    mounted() {

    },
    methods: {
        initRefCurve() {
            let url = API_URL["fixInit"];
            let params = {
                mac: this.mac,
            }
            axios.get(url, {
                params: params
            })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.$store.commit('setBreadcrumbItems', [
                            { title: setSidbarBreadCrumb(res.data.data.machine), machine: res.data.data.machine }
                        ]);
                        const data = res.data.data.fix;
                        if (data && data.length > 0) {
                            let filteredData = data.filter(c => c && c.type == 1);
                            if (filteredData.length > 0) {
                                this.isFromRecord = true;
                                let oneFix = filteredData[0];
                                this.programBefore = oneFix.program_before;
                                this.programAfter = oneFix.program_after;
                                this.saveRange = oneFix.save_range;
                                this.refRange = oneFix.ref_range;
                                const beforeCurve = jsonParseSafe(oneFix.ref_res_curve_before);
                                const afterCurve = jsonParseSafe(oneFix.ref_res_curve_after);
                                if (Array.isArray(beforeCurve) && beforeCurve.length > 0 &&
                                    Array.isArray(afterCurve) && afterCurve.length > 0) {
                                    this.xAxisData = Array.from({ length: Math.min(beforeCurve.length, afterCurve.length) }, (_, i) => i);
                                    this.aSeries.push({
                                        key: "fix-before-avg",
                                        name: this.getTranslation('p038'),
                                        type: 'line',
                                        showSymbol: false,
                                        lineStyle: { width: 2, color: '#6495ed' },
                                        z: 20,
                                        data: beforeCurve
                                    });
                                    this.aSeries.push({
                                        key: "fix-after-avg",
                                        name: this.getTranslation('p039'),
                                        type: 'line',
                                        showSymbol: false,
                                        lineStyle: { width: 2, color: '#ff7f50' },
                                        z: 20,
                                        data: afterCurve
                                    });
                                    this.reChart();
                                }
                            }
                        }

                    }
                })
        },
        async query() {
            this.isLoadingQuery = true;
            let url = API_URL["fixQuery"];
            let params = {
                mac: this.mac,
                program_before: this.programBefore,
                program_after: this.programAfter
            }
            let res = await axios.get(url, {
                params: params
            })
            this.isLoadingQuery = false;
            let fixRecord = [];
            if (res && res.data && res.data.code == 200) {

                if (Array.isArray(res.data.data)) {
                    res.data.data.forEach(record => {
                        let hasCurve = true;
                        if (Array.isArray(record)) {
                            record.forEach(r => {
                                if (!r.Curves || r.Curves.length === 0) {
                                    hasCurve = false;
                                }
                            });
                        } else {
                            hasCurve = false;
                        }
                        if (hasCurve) {
                            fixRecord.push(record);
                        }
                    });
                }
            }
            this.fixRecord = fixRecord;

        },
        initChart() {
            this.$nextTick(() => {
                const parentWidth = this.$refs.charts.offsetWidth - 50;                
                this.chartWidth = `${parentWidth}px`;
                this.myChart = this.$echarts.init(this.$refs.charts);

                this.setBrush();
            })
        },
        setBrush() {
            // 确保移除之前的事件监听器
            this.myChart.getZr().off('mousedown');
            //this.myChart.getZr().off('mousemove');
            this.myChart.getZr().off('mouseup');
            this.myChart.getZr().off('dblclick');

            // 绑定事件
            const zr = this.myChart.getZr();

            zr.on('mousedown', (e) => {
                if (e.event.which !== 1) return; // only left button

                // only activate brush inside the grid, ignore clicks on toolbox and elsewhere
                const inGrid = this.myChart.containPixel({ gridIndex: 0 }, [e.offsetX, e.offsetY]);
                if (!inGrid) return;

                this.isSelecting = true;
                this.startPos = { x: e.offsetX, y: e.offsetY };

                const gridModel = this.myChart.getModel().getComponent('grid', 0);

                if (gridModel) {
                    const grid = gridModel.coordinateSystem;
                    const rect = grid.getRect();

                    this.myChart.setOption({
                        graphic: {
                            id: 'selectionRect',
                            type: 'rect',
                            invisible: false,
                            shape: {
                                x: this.startPos.x,
                                y: rect.y,
                                width: 0,
                                height: rect.height
                            },
                            style: {
                                fill: 'rgba(150, 150, 150, 0.3)',
                                stroke: '#999',
                                lineWidth: 1,
                            },
                        }
                    });
                }
            });

            zr.on('mousemove', (e) => {
                if (this.isSelecting && this.startPos) {
                    const width = e.offsetX - this.startPos.x;
                    this.myChart.setOption({
                        graphic: {
                            id: 'selectionRect',
                            shape: { width }
                        }
                    });
                }
            });

            zr.on('mouseup', (e) => {
                if (this.isSelecting && this.startPos) {
                    this.isSelecting = false;

                    const endPos = { x: e.offsetX, y: e.offsetY };
                    const width = Math.abs(endPos.x - this.startPos.x);

                    if (width > 10) {
                        this.applyZoom(this.startPos.x, endPos.x);
                    }

                    this.myChart.setOption({
                        graphic: {
                            id: 'selectionRect',
                            invisible: true
                        }
                    });

                    this.startPos = null;
                }
            });

            zr.on('dblclick', (e) => {
                // only reset zoom when double-click happens inside the grid
                const inGrid = this.myChart.containPixel({ gridIndex: 0 }, [e.offsetX, e.offsetY]);
                if (!inGrid) return;

                this.myChart.dispatchAction({
                    type: 'dataZoom',
                    dataZoomId: 'dataZoomX',
                    start: 0,
                    end: 100
                });
            });
        },

        applyZoom(startPixel, endPixel) {
            const xAxis = this.myChart.getModel().getComponent('xAxis', 0);

            if (!xAxis) return;

            const axis = xAxis.axis;
            const pixelExtent = axis.getGlobalExtent();
            const minX = Math.min(startPixel, endPixel);
            const maxX = Math.max(startPixel, endPixel);

            // 确保在轴范围内
            const clampedMin = Math.max(minX, pixelExtent[0]);
            const clampedMax = Math.min(maxX, pixelExtent[1]);

            if (clampedMax <= clampedMin) return;

            // 计算百分比
            const startPercent = (clampedMin - pixelExtent[0]) / (pixelExtent[1] - pixelExtent[0]) * 100;
            const endPercent = (clampedMax - pixelExtent[0]) / (pixelExtent[1] - pixelExtent[0]) * 100;
            this.myChart.dispatchAction({
                type: 'dataZoom',
                dataZoomId: 'dataZoomX',
                start: startPercent,
                end: endPercent
            });
        },
        selectRecord(index) {
            if (this.selectedMap[index]) {
                // 反选
                this.$delete(this.selectedMap, index);
                this.rebuildFromSelections();
                return;
            }
            // 首次选择时校验并缓存
            if (!this.ensureRecordCached(index)) {
                return;
            }
            this.$set(this.selectedMap, index, true);
            this.isFromRecord = false;
            this.rebuildFromSelections();

        },
        selectType(index) {
            return this.selectedMap[index] ? 'success' : 'default';
        },

        // 校验并解析缓存指定记录；仅在首次选择时做一次
        ensureRecordCached(index) {
            if (this.parsedCache[index]) return true;

            const rec = this.fixRecord[index];
            if (!rec || !rec[0] || !rec[1]) {
                this.$Message.error(this.getTranslation('p029'));
                return false;
            }
            const before = rec[0].Curves;
            const after = rec[1].Curves;
            if (!before || !after) {
                this.$Message.error(this.getTranslation('p029'));
                return false;
            }
            const parseContent = (c) => {
                if (!c) return [];
                const v = c.content;
                if (Array.isArray(v)) return v;
                if (typeof v === 'string') {
                    try { return JSON.parse(v); } catch (e) { return []; }
                }
                return [];
            };

            const beforeCurves = before
                .filter(c => c && c.kind === 2)
                .map(c => ({ ...c, content: parseContent(c) }));
            const afterCurves = after
                .filter(c => c && c.kind === 2)
                .map(c => ({ ...c, content: parseContent(c) }));

            if (beforeCurves.length === 0 || afterCurves.length === 0) {
                this.$Message.error(this.getTranslation('p032'));
                return false;
            }
            let beforeContent = beforeCurves[0].content;
            let afterContent = afterCurves[0].content;
            if (!Array.isArray(beforeContent) || beforeContent.length === 0 ||
                !Array.isArray(afterContent) || afterContent.length === 0) {
                this.$Message.error(this.getTranslation('p029'));
                return false;
            }
            if (beforeContent.length !== afterContent.length) {
                this.$Message.error(this.getTranslation('p031'));
                return false;
            }
            let validCurve = this.aSeries.filter(s => s.key !== 'fix-before-avg' && s.key !== 'fix-after-avg');
            if (validCurve.length > 0) {
                const firstValidCurve = validCurve[0];
                if (beforeContent.length !== firstValidCurve.data.length ||
                    afterContent.length !== firstValidCurve.data.length) {
                    this.$Message.error(this.getTranslation('p033'));
                    return false;
                }
            }

            this.$set(this.parsedCache, index, {
                before: beforeCurves[0], after: afterCurves[0],
                before_create_at: rec[0].created_string,
                after_create_at: rec[1].created_string
            });
            return true;
        },

        // 根据已选记录重建所有序列和X轴
        rebuildFromSelections() {
            const indices = Object.keys(this.selectedMap).map(k => parseInt(k, 10)).filter(k => this.selectedMap[k]);
            if (indices.length === 0) {
                // 清空图形
                this.xAxisData = [];
                const removedNames = new Set(this.aSeries.map(s => s.name));
                this.aSeries = [];
                // 清理 legendSelected 中已不存在的系列名                
                Object.keys(this.legendSelected).forEach(name => {
                    if (!removedNames.has(name)) {
                        // keep nothing since we are clearing chart
                    }
                });
                this.legendSelected = {};
                this.reChart();
                return;
            }

            // 计算所有已选曲线的统一长度（全局最小）
            let unifiedLen = Infinity;
            indices.forEach(idx => {
                const cache = this.parsedCache[idx] || {};
                const len = Array.isArray(cache.before.content) ? cache.before.content.length : 0;
                if (len > 0) unifiedLen = Math.min(unifiedLen, len);

            });
            if (!isFinite(unifiedLen) || unifiedLen <= 0) {
                this.$Message.error(this.getTranslation('p029'));
                return;
            }

            this.xAxisData = Array.from({ length: unifiedLen }, (_, i) => i);

            const newSeries = [];
            const newLegendNames = [];
            indices.forEach(idx => {
                const cache = this.parsedCache[idx];
                if (!cache) return;

                // 简洁唯一标签：按记录序号

                const c = cache.before;
                const name = this.getTranslation('p034') + `-` + this.cutYear(cache.before_create_at);
                newSeries.push({
                    color: "#800080",
                    name,
                    type: 'line',
                    showSymbol: false,
                    data: (c.content || []).slice(0, unifiedLen)
                });
                newLegendNames.push(name);


                const cAfter = cache.after;
                const nameAfter = this.getTranslation('p035') + `-` + this.cutYear(cache.after_create_at);
                newSeries.push({
                    color: "#32cd32",
                    name: nameAfter,
                    type: 'line',
                    showSymbol: false,
                    data: (cAfter.content || []).slice(0, unifiedLen)
                });
                newLegendNames.push(nameAfter);

            });

            // 合并旧的 legend 选择状态，新增默认选中，已删除自动丢弃
            const mergedSelected = {};
            newLegendNames.forEach(n => {
                // eslint-safe own check
                mergedSelected[n] = Object.prototype.hasOwnProperty.call(this.legendSelected, n)
                    ? this.legendSelected[n]
                    : true;
            });
            this.legendSelected = mergedSelected;

            this.aSeries = newSeries;
            this.reChart();
        },

        // ...existing code reChart remains; it already uses array-form axes and legend selections...
        reChart() {
            const legendData = this.aSeries.map(s => s.name);
            const selected = {};
            legendData.forEach(n => {
                selected[n] = Object.prototype.hasOwnProperty.call(this.legendSelected, n)
                    ? this.legendSelected[n]
                    : true;
            });
            this.legendSelected = selected;

            this.myChart.setOption({
                // reserve space so legend never overlaps the chart
                grid: {
                    top: 20,
                    left: 10,
                    right: 10,
                    bottom: 64,          // space for the scroll legend
                    containLabel: true
                },
                xAxis: [{
                    axisLine: { onZero: true },
                    type: 'category',
                    boundaryGap: false,
                    splitLine: { show: true },
                    axisLabel: {
                        formatter: function (value) {
                            const v = parseInt(value, 10);
                            return isNaN(v) ? value : String(v);
                        }
                    },
                    data: this.xAxisData
                }],
                yAxis: [{
                    axisLine: { onZero: true },
                    type: 'value'
                }],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'line' },
                    formatter: (params) => {
                        let tooltipText = '';
                        if (Array.isArray(params)) {
                            params.forEach(p => {
                                if (p && p.seriesName) {
                                    tooltipText += `${p.seriesName}: ${p.data}<br/>`;
                                }
                            });
                        }
                        return tooltipText;
                    },
                     confine: true
                },
                // make legend scrollable and stick to the bottom
                legend: {
                    type: 'scroll',
                    // orient: 'horizontal',
                    bottom: 0,
                    left: 10,
                    right: 10,
                    data: legendData,

                },
                series: this.aSeries,
                dataZoom: [
                    {
                        id: 'dataZoomX',
                        type: 'slider',
                        xAxisIndex: 0,
                        bottom: 30,
                        filterMode: 'empty',
                        showDataShadow: true,
                        start: 0,
                        show: false,
                        end: 100
                    },

                ],
            }, true);
        },
        createRefCurve() {
            const indices = Object.keys(this.selectedMap)
                .map(k => parseInt(k, 10))
                .filter(k => this.selectedMap[k]);

            if (indices.length === 0) {
                this.$Message.error(this.getTranslation('p036'));
                return;
            }
            if (this.checkCanCreateRefCurve() === false) {
                return;
            }

            // 收集所有已选的修磨前/修磨后曲线内容（数组）
            const beforeList = [];
            const afterList = [];
            indices.forEach(idx => {
                const cache = this.parsedCache[idx];
                if (!cache) return;
                const c = cache.before;
                if (Array.isArray(c.content) && c.content.length > 0) beforeList.push(c.content);

                const cAfter = cache.after;
                if (Array.isArray(cAfter.content) && cAfter.content.length > 0) afterList.push(cAfter.content);
            });

            if (beforeList.length === 0 && afterList.length === 0) {
                this.$Message.error(this.getTranslation('p036'));
                return;
            }


            // 统一长度：优先使用当前xAxis长度，否则取所有曲线的最小长度
            let unifiedLen = this.xAxisData && this.xAxisData.length > 0 ? this.xAxisData.length : Infinity;
            const allLists = beforeList.concat(afterList);
            allLists.forEach(arr => {
                if (Array.isArray(arr) && arr.length > 0) {
                    unifiedLen = Math.min(unifiedLen, arr.length);
                }
            });

            if (!isFinite(unifiedLen) || unifiedLen <= 0) {
                this.$Message.error(this.getTranslation('p037'));
                return;
            }
            if (!this.xAxisData || this.xAxisData.length === 0) {
                this.xAxisData = Array.from({ length: unifiedLen }, (_, i) => i);
            }

            // 计算平均曲线
            const averageSeries = (lists) => {
                return Array.from({ length: unifiedLen }, (_, i) => {
                    let sum = 0;
                    let cnt = 0;
                    for (const arr of lists) {
                        const v = arr[i];
                        if (typeof v === 'number' && !isNaN(v)) {
                            sum += v;
                            cnt++;
                        }
                    }
                    return cnt ? +(sum / cnt).toFixed(3) : null;
                });
            };

            const beforeAvg = beforeList.length ? averageSeries(beforeList) : null;
            const afterAvg = afterList.length ? averageSeries(afterList) : null;

            // 移除旧的参考曲线            
            this.aSeries = this.aSeries.filter(s => s.key !== 'fix-before-avg' && s.key !== 'fix-after-avg');

            // 追加新的参考曲线（加粗，区分颜色）
            if (beforeAvg) {
                this.aSeries.push({
                    key: "fix-before-avg",
                    name: this.getTranslation('p038'),
                    type: 'line',
                    showSymbol: false,
                    lineStyle: { width: 2, color: '#6495ed' },
                    z: 20,
                    data: beforeAvg
                });
                this.legendSelected[this.getTranslation('p038')] = true;
            }
            if (afterAvg) {
                this.aSeries.push({
                    key: "fix-after-avg",
                    name: this.getTranslation('p039'),
                    type: 'line',
                    showSymbol: false,
                    lineStyle: { width: 2, color: '#ff7f50' },
                    z: 20,
                    data: afterAvg
                });
                this.legendSelected[this.getTranslation('p039')] = true;
            }

            this.reChart();
        },
        checkCanCreateRefCurve() {
            let rs = true;
            const indices = Object.keys(this.selectedMap)
                .map(k => parseInt(k, 10))
                .filter(k => this.selectedMap[k]);

            for (let i = 0; i < indices.length; i++) {
                const idx = indices[i];
                const cache = this.parsedCache[idx] || {};
                if (!cache.before || !cache.after || !cache.after.content || !cache.before.content) {
                    this.$Message.error(this.getTranslation('p037'));
                    rs = false;
                    return rs;
                } else if ((cache.before.content.length !== cache.after.content.length)) {
                    this.$Message.error(this.getTranslation('p031'));
                    rs = false;
                    return rs;
                } else {
                    for (let i = 0; i < cache.before.content.length; i++) {
                        const vAfter = cache.after.content[i];
                        const vBefore = cache.before.content[i];

                        if (vBefore - vAfter > this.saveRange) {
                            this.$Message.error(this.getTranslation('p044'));
                            rs = false;
                            return rs;
                        }
                    }
                    // 校验内容长度一致性
                }
            }


            return rs;

        },
        saveRefCurve() {
            const curveAfter = this.aSeries.find(s => s.key === 'fix-after-avg');
            const curveBefore = this.aSeries.find(s => s.key === 'fix-before-avg');
            if (!curveBefore) {
                this.$Message.error(this.getTranslation('p040'));
                return;
            }
            if (!curveAfter) {
                this.$Message.error(this.getTranslation('p040'));
                return;
            }
            let url = API_URL["fixSaveRefCurve"];
            let params = new FormData();
            params.append('mac', this.mac);
            params.append('program_after', this.programAfter);
            params.append('program_before', this.programBefore);
            params.append('ref_res_curve_before', JSON.stringify(curveBefore.data));
            params.append('ref_res_curve_after', JSON.stringify(curveAfter.data));
            params.append('save_range', this.saveRange);
            params.append('ref_range', this.refRange);
            axios.post(url, params)
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.$Message.success(res.data.msg);
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.message);
                    } else {
                        this.$Message.error(this.getTranslation('c001'));
                    }
                })
                .catch(err => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                });
        },
        cutYear(dateString) {
            if (!dateString || dateString.length < 4) return dateString;
            return dateString.substring(5);
        }
    }
}
</script>

<style scoped>
@import url("../../assets/style/list.css");
@import url("../../assets/style/tab.css");

.fix-record-block {
    margin-top: 10px;
    width: 100%;
    max-height: 500px;
    overflow-y: auto;
}

.one-fix {
    display: inline-flex;
    margin-right: 10px;
}

.right-fix {
    padding-left: 4px;
    height: calc(100vh - 260px);
    overflow-y: auto;
    overflow-x: hidden;
    flex: 0 0 600px;
    /* adjust fixed width as needed */
    max-width: 600px;
}

.second-fieldset {
    margin-top: 10px;
}
</style>